/**
 * Экспорт компонентов футера таблицы
 */

export { TableFooter } from "./TableFooter";
